export default __webpack_public_path__ + "static/media/march2023-5.f7f93196.jpg";